export const SETTINGS_TYPES = {
    "profile": "Профиль",
    "personalization": "Персонализация",
    "userRolesSettings": "Настройки ролей",
    "userRoles": "Роли",
    "allUsersSettings": "Учетные записи",
    "allOrganizations": "Организации",
    "allCustomers": "Заказчики",
    "allUsers": "Пользователи",
    "adminMaterialSettings": "Настройки материалов",
    "adminMaterialGroups": "Группы материалов",
    "adminMaterial": "Материалы",
    "adminImports": "Импорт",
    "adminExports": "Экспорт",
    "jobSettings": "Настройки работ",
    "listJobPacking": "Упаковки",
    "listJobMilling": "Фрезерование",
    "listJobEdge": "Кромление",
    "listJobDrilling": "Сверление",
    "listJobCutting": "Раскрой",
    "samplesSettings": "Настройки шаблонов",
    "systemSamples": "Шаблоны системы",
    "systemSamplesGroup": "Группы",
    "systemSamplesEdges": "Кромки",
    "currencySettings": "Настройки валюты",
    "currency": "Валюта",
    "currenciesNationalBank": "Курсы валют",
    "adminSuppliersSettings": "Настройки поставщиков",
    "adminSuppliers": "Поставщики",
    "adminManufacturerSettings": "Настройки производителей",
    "adminManufacturer": "Производители",
    "unitSettings": "Настройки единиц измерения",
    "unit": "Единицы измерения",
    "ratingSettings": "Настройки рейтинга",
    "rating": "Рейтинг организаций",
    "vacancySettings": "Настройки вакансий",
    "vacancy": "Вакансии",
    "helpSettings": "Настройки помощи",
    "themeHelp": "Темы",
    "help": "Помощь",
    "newsSettings": "Настройки новостей",
    "themeNews": "Темы",
    "news": "Новости",
    "promotionSettings": "Настройки акций",
    "themePromotion": "Темы",
    "promotion": "Акции",
    "pictureSettings": "Настройки изображений",
    "picture": "Изображения",
    "filesSettings": "Настройки файлов",
    "files": "Файлы",
    "folders": "Папки",
    "errorsSettings": "Ошибки",
    "errors": "Ошибки",
    "cache": "Кэш",
    "cacheOrders": "Сервис заказы",
    "cacheModels": "Сервис модели",
    "cacheAuthorization": "Сервис авторизации",
    "relatedUsers": "Связанные пользователи",
    "favorite-organization": "Избранные организации",
    "customerSettings": "Настройки",
    "adress": "Адреса",
    "addressList": "Список адресов",
    "generalSettings": "Основные настройки",
    "setupStages": "Этапы настройки",
    "warehouseSettings": "Настройки склада",
    "warehouseName": "Наименования складов",
    "materialGroups": "Группы материалов",
    "material": "Материалы",
    "imports": "Импорт",
    "exports": "Экспорт",
    "listJob": "Наименования работ",
    "listJobName": "Найменования затрат по работам",
    "listTypeJob": "Группы работ",
    "importJob": "Импорт",
    "orderSettings": "Настройки заказа",
    "headers": "Заголовки заказов",
    "attributes": "Aтрибуты заказов",
    "modelSettings": "Настройки моделей",
    "packagingUnits": "Единицы упаковки",
    "packagingSets": "Комплекты упаковки",
    "detailModels": "Детали моделей",
    "basicModels": "Базовые модели",
    "models": "Модели",
    "importModels": "Импорт",
    "modelEdges": "Кромки",
    "workerSettings": "Настройки сотрудников",
    "workers": "Работники",
    "organizationCustomersSettings": "Настройки заказчиков",
    "organizationCustomers": "Заказчики",
    "organizationSuppliersSettings": "Настройки поставщиков",
    "organizationSuppliers": "Поставщики",
    "optimizationSettings": "Настройки оптимизации",
    "rulesModifyingOptimization": "Правила модификации",
    "reserveSettings": "Настройки резервов деталей",
    "edgeReserveSettings": "Кромки",
    "CNCSettings": "Настройки ЧПУ",
    "CuttingSettings": "Настройки Раскроя",
    "BiesseSettings": "Biesse",
    "selcoFileFields": "Порядок экспорта полей Selco",
    "MillingDrillingSettings": "Настройки фрезерования присадки и сверления",
    "machines": "Станки",
    "postprocessors": "Настройки постпроцессоров",
    "compositionSettings": "Настройки композиции",
    "composition": "Композиции",
    "compositionMedia": "Медиа композиций",
    "compositionPictures": "Картинки",
    "compositionTextures": "Текстуры",
    "modules": "Модули",
    "moduleDetails": "Детали модулей",
    "compositionEdges": "Кромки",
}